import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { RESIDENTS_DESKTOP_COLORS } from '@/constants/residents/desktop/color';
import { RESIDENTS_SVG_COMPONENTS } from '@/assets/residents';
import { DesktopOverflowText } from '@/components/common/admin/desktop/DesktopOverflowText';

interface PaymentSectionHeaderProps {
  title: string;
  tooltipText?: string;
  style?: any;
}

export const PaymentSectionHeader: React.FC<PaymentSectionHeaderProps> = ({
  title,
  tooltipText,
  style,
}) => {
  return (
    <View style={[styles.sectionHeader, style]}>
      <Text style={styles.sectionTitle}>{title}</Text>
      {!!tooltipText && (
        <View style={styles.tooltipContainer}>
          <DesktopOverflowText
            text=""
            title=""
            tooltipText={tooltipText}
            numberOfLines={1}
            icon={(() => {
              const Icon = (RESIDENTS_SVG_COMPONENTS as any).INFORMATION_CIRCLE;
              return Icon ? <Icon width={18} height={18} color={RESIDENTS_DESKTOP_COLORS.TEXT_TERTIARY} /> : null;
            })()}
          />
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  sectionHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 12,
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: '700',
    color: RESIDENTS_DESKTOP_COLORS.TEXT_PRIMARY,
    marginRight: 8,
  },
  tooltipContainer: {
    marginLeft: 8,
    width: 18,
    height: 18,
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
  },
});
